export default __webpack_public_path__ + "static/media/Background_00241.cade22a2.png";